import * as React from 'react'

import SavedBtn from './SavedBtn'
import ExcelBtn from './excelBtn'

export default function CommonFiltersActions({page}) {
    return <>
        <ExcelBtn />
        <SavedBtn page={page}/>
    </>
}